import {MC_Device} from "../common/iot/MC_Device";
import {Chiller} from "./devices/chiller/Chiller";

// Class to define what devices can be created
export interface CustomDevice {
    rawType: string,
    fullTypeName: string,
    description: string
}
// Create device
export class CustomDeviceFactory {

    // Devices
    public static TYPE_CHILLER: string = "CHILL";
    public static FULL_TYPE_CHILLER: string = "Chiller";

    public static SUPPORTED_DEVICES: CustomDevice[] = [
        {
            rawType: this.TYPE_CHILLER,
            fullTypeName: this.FULL_TYPE_CHILLER,
            description: ""
        }
    ];

    public static fromData(data: any): MC_Device {
        const type: string | null = (data[MC_Device.FIELD_TYPE] != null)
            ? data[MC_Device.FIELD_TYPE] as string
            : null
        ;
        if (type == null) {
            throw "Missing device type";
        }
        // Custom device types
        switch (type) {
            case this.TYPE_CHILLER: return new Chiller(data);
        }
        // Return base device as default
        return new MC_Device(data);
    }

    public static getArrayFromData(dataArray: any[]): MC_Device[] {
        let devices: MC_Device[] = [];
        for (let i = 0; i < dataArray.length; i++) {
            try {
                devices = devices.concat(this.fromData(dataArray[i]));
            } catch (e) {
                console.error("Device parse err: " + e + ": " + JSON.stringify(dataArray[i]));
            }
        }
        return devices;
    }

    public static getFullDeviceType(type: string): string {
        switch (type) {
            case this.TYPE_CHILLER: return this.FULL_TYPE_CHILLER;
        }
        return "Unknown";
    }

}
